interface LogoProps {
  /** Hide the wordmark — shows only the icon mark. */
  withWordmark?: boolean;
  /**
   * Render for a dark background (e.g. LoginPage hero panel).
   *
   * Historical note: this used to apply `brightness-0 invert` to the
   * primary asset. That collapsed every color to white — including the
   * white squircle behind the icon — so the bridge mark + wordmark
   * disappeared into a solid white blob (ROADS-516). We now swap to a
   * dedicated `/logo-white.svg` whose squircle plate is transparent and
   * whose dark elements are recolored white, preserving the brand
   * accent yellow as the only non-monochrome element.
   */
  onDark?: boolean;
}

export default function Logo({ withWordmark = true, onDark = false }: LogoProps) {
  if (withWordmark) {
    return (
      <img
        src={onDark ? "/logo-white.svg" : "/logo.svg"}
        alt="RoadBridge"
        height={40}
        className="h-10 w-auto"
      />
    );
  }
  return (
    <img
      src="/favicon.png"
      alt="RoadBridge"
      width={32}
      height={32}
      className="h-8 w-8"
    />
  );
}
